module.exports = __webpack_public_path__ + "../fonts/slick.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slick-carousel/slick/fonts/slick.eot
// module id = 152
// module chunks = 0